import {Component, computed, inject, input, output, signal, TemplateRef, WritableSignal} from '@angular/core';
import {NgbOffcanvas, OffcanvasDismissReasons} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-dropdown-filters',
    templateUrl: './app-dropdown-filters.component.html',
    styleUrls: ['./app-dropdown-filters.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class AppDropdownFiltersComponent {
    // Inputs
    buttonLabelKey = input<string>('Filtro Avançado');
    applyButtonLabelKey = input<string>('Aplicar');
    clearButtonLabelKey = input<string>('Limpar');
    disabled = input<boolean>(false);
    activeFiltersCount = input<number>(0);
    showClearButton = input<boolean>(true);

    // Outputs
    onApply = output<void>();
    onClear = output<void>();

    // Computed properties
    hasActiveFilters = computed(() => this.activeFiltersCount() > 0);
    buttonClass = computed(() =>
        this.hasActiveFilters() ? 'btn btn-outline-dark' : 'btn btn-outline-dark'
    );

    private offCanvasService = inject(NgbOffcanvas);
    closeResult: WritableSignal<string> = signal('');

    open(content: TemplateRef<any>) {
        this.offCanvasService.open(content, {ariaLabelledBy: 'offcanvas-basic-title', position: 'end'}).result.then(
            (result: any) => {
                this.closeResult.set(`Closed with: ${result}`);
            },
            (reason: any) => {
                this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
            },
        );
    }

    private getDismissReason(reason: any): string {
        switch (reason) {
            case OffcanvasDismissReasons.ESC:
                return 'by pressing ESC';
            case OffcanvasDismissReasons.BACKDROP_CLICK:
                return 'by clicking on the backdrop';
            default:
                return `with: ${reason}`;
        }
    }

    onApplyClick(): void {
        this.onApply.emit();
        this.offCanvasService.dismiss('apply');
    }

    onClearClick(): void {
        this.onClear.emit();
        this.offCanvasService.dismiss('clear');
    }
}
